import styles from './Svg.module.scss';

const HanabiLogoLoading = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="40"
      viewBox="0 0 29 40"
      fill="none"
    >
      <path
        d="M0 2.71196C0.75023 1.87352 1.6824 1.21049 2.72808 0.771568C3.79739 0.281867 4.96015 0.0192831 6.14015 0.00102262C7.32015 -0.0172378 8.49077 0.209237 9.5753 0.665608C11.9826 1.65898 13.2521 3.55633 13.7383 5.9901C13.9059 6.84788 13.9895 7.71938 13.9882 8.59275C14.0039 16.4912 14.0039 24.3874 13.9882 32.2815V33C13.1407 32.8841 12.3473 32.8179 11.5707 32.6689C9.85803 32.3489 8.23557 31.6713 6.81346 30.6821C4.35886 28.9503 3.06234 26.6291 3.06909 23.6292C3.06909 18.3974 3.06909 13.1656 3.06909 7.93381C3.10489 6.87162 2.9318 5.81261 2.55927 4.81461C2.10346 3.69872 1.37079 2.88415 0 2.71196Z"
        fill="url(#paint0_linear_1_401)"
        className={styles.animation}
      />
      <path
        d="M15 17.6126C16.0847 16.4742 17.4944 15.6661 19.0541 15.2884C20.8016 14.8262 22.6587 14.9216 24.3446 15.5603C27.0473 16.5638 28.3615 18.6031 28.8108 21.2316C28.9322 21.992 28.9899 22.7606 28.9831 23.5299C29.0056 28.8106 29.0056 34.0924 28.9831 39.3752V40C28.5946 39.9806 28.223 39.9806 27.8581 39.9353C25.3696 39.7041 23.0098 38.7663 21.0811 37.242C20.1172 36.4937 19.344 35.5448 18.82 34.4673C18.2961 33.3898 18.0353 32.2121 18.0574 31.0237C18.0574 28.2366 18.0946 25.4495 18.0372 22.6624C18.0129 21.7134 17.8619 20.7713 17.5878 19.8591C17.1926 18.5513 16.4223 17.9492 15 17.6126Z"
        fill="url(#paint1_linear_1_401)"
        className={styles.animation}
      />
      <defs>
        <linearGradient
          id="paint0_linear_1_401"
          x1="6.99916"
          y1="33"
          x2="6.99916"
          y2="0.00335921"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8A181A" className={styles.animation} />
          <stop offset="1" stopColor="#F04923" className={styles.animation} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1_401"
          x1="21.9932"
          y1="39.9935"
          x2="21.9932"
          y2="15.0003"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8A181A" className={styles.animation} />
          <stop offset="1" stopColor="#F04923" className={styles.animation} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default HanabiLogoLoading;
